import { Scan } from '@scans/types';
import type { NewPoint } from '@trenches/types';
import { proxy } from 'valtio';

interface FromPoint {
  fromPoint?: NewPoint;
  fromPointId?: string;
}

interface ScansState {
  selectedScan: Scan | null;
  scans: Scan[];
}

/**
 * We use valtio here and not useState() because we use this state in multiple components!
 */
export const trenchFromPointState = proxy<FromPoint>({});

export const setTrenchFromPoint = (point?: NewPoint, pointId?: string): void => {
  trenchFromPointState.fromPoint = point;
  trenchFromPointState.fromPointId = pointId;
};

export const resetTrenchFromPoint = (): void => {
  trenchFromPointState.fromPoint = undefined;
  trenchFromPointState.fromPointId = undefined;
};

export const scansState = proxy<ScansState>({
  selectedScan: null,
  scans: [],
});

export const setSelectedScan = (scan: Scan | null): void => {
  scansState.selectedScan = scan;
};

export const updateScanInScansState = (updatedScan: Scan): void => {
  scansState.scans = scansState.scans.map((scan) =>
    scan.id === updatedScan.id ? updatedScan : scan,
  );
};
